﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_usuarios/usuarios-auditoria";

export const Route = createFileRoute("/_authenticated/usuarios-auditoria")({
  head: () => ({
    meta: [
      { title: "Relatório de auditoria — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Acompanhe todas as operações registradas por usuário: estoque, vendas, mensagens e cadastros.",
      },
      { property: "og:title", content: "Relatório de auditoria — Milky Moo Palmares" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
